"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwisterButton = void 0;
const react_1 = __importStar(require("react"));
const tooltip_1 = require("../../tooltip");
const styles_1 = require("./styles");
const TwisterButton = ({ dimensionValueIndex, dimensionKeyIndex, variationState, asin, e, handleOnClick, setHoverState, seeAvailableOptionsCopy }) => {
    const [buttonHoverState, setButtonHoverState] = (0, react_1.useState)(false);
    return (react_1.default.createElement(styles_1.StyledTwisterButton, { first: dimensionValueIndex === 0, selected: variationState[dimensionKeyIndex] === dimensionValueIndex, isValid: !!asin, key: e, onClick: () => {
            handleOnClick(dimensionKeyIndex, dimensionValueIndex);
        }, onMouseEnter: () => {
            setButtonHoverState(true);
            setHoverState([dimensionKeyIndex, dimensionValueIndex]);
        }, onMouseLeave: () => {
            setButtonHoverState(false);
            setHoverState(undefined);
        } },
        react_1.default.createElement(styles_1.ButtonText, { isValid: !!asin, bold: variationState[dimensionKeyIndex] === dimensionValueIndex }, e),
        !asin && buttonHoverState && react_1.default.createElement(tooltip_1.Tooltip, null, seeAvailableOptionsCopy)));
};
exports.TwisterButton = TwisterButton;
